import * as React from 'react';

const SvgWarningNotification = (props) => (
  <svg
    width={56}
    height={56}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#FFE6E6" />
    <circle cx={28} cy={32} r={1} fill="#E31B54" />
    <path
      d="M27.9999 24V29M20.3279 36H35.6721C37.4445 36 38.5649 34.1433 37.7041 32.6324L30.032 19.1659C29.1464 17.6114 26.8536 17.6114 25.968 19.1659L18.2959 32.6324C17.4351 34.1433 18.5555 36 20.3279 36Z"
      stroke="#E31B54"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#FFF7F7"
      strokeWidth={8}
    />
  </svg>
);

export default SvgWarningNotification;
